import { DialogBody } from "@blueprintjs/core";
import { useWrapup } from "../wrapupcontext";
import { WrapupModuleKillsData } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import pluralize from "@/src/util/pluralize";
import Image from "next/image";
import styles from './wrapup.module.css';

export default function WrapupModuleKillsContinued2Component(): React.ReactNode {
    const { wrapupData } = useWrapup();

    const data = wrapupData.data.kills as WrapupModuleKillsData;

    return <DialogBody className={styles.dialogBody}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
            <h1>Kills Continued 2</h1>
            <Image src='/images/emojis/ettu.png' width={256} height={256} alt='victory' />
            <h3>Your killing sprees (player eliminations in a single turn):</h3>
            <table>
                <thead>
                    <tr style={{ fontWeight: 'bold' }}>
                        <td>Spree</td>
                        <td>Count</td>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.sprees.map(
                            (entry) => {
                                const kills = entry[0];
                                const count = entry[1];

                                return <tr key={kills}>
                                    <td align="center">{kills}</td>
                                    <td align="center">{count}</td>
                                </tr>
                            }
                        )
                    }
                </tbody>
            </table>
            <h3 style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <picture>
                    <img
                        src={`/images/robot.png`}
                        alt={'bot'}
                        draggable={false}
                        width={32}
                        height={32}
                    />
                </picture>
                <span style={{ margin: '8px' }}>
                    You also killed {pluralize(data.botKills, 'bot')} and died to bots {pluralize(data.botDeaths, 'time')}
                </span>
                <picture>
                    <img
                        src={`/images/robot.png`}
                        alt={'bot'}
                        draggable={false}
                        width={32}
                        height={32}
                    />
                </picture>
            </h3>
        </div>
    </DialogBody>
}
